<!-- Main container -->
<div class="layout-col full pt-sm">
  <!-- Search Component -->
  <elder-table
    class="flex"
    matSort
    [data]="data"
    [idField]="'id'"
    (itemClick)="openDetail($event)"
    [selectionVisible]="true"
    [selectionMultiEnabled]="true"
  >
    <elder-data-toolbar *elderTableToolbar [canRemove]="false" [canAdd]="false" [canMore]="true">
      <button
        mat-menu-item
        [disabled]="!selection()?.length"
        (click)="assignMissingProductionRoute(selection())"
      >
        <mat-icon>linear_scale</mat-icon>
        <span>{{ 'work_order_commands.ASSIGN_PROD_ROUTES' | translate }}</span>
      </button>

      <ng-template elderToolbarContent="center">
        <elder-search-box
          dense
          class="flex-60 pt-xs"
          queryKey="query"
          [autoPanel]="false"
          [elderSearchContext]="data.filter"
          [forcedFilters]="getFilters(forcedFiltersByKey$ | async)"
        >
          <!-- Advanced search -->
          <elder-search-panel class="layout-col p-sm">
            <div class="layout-row place-start-center gap-sm">
              <mat-form-field>
                <mat-label>{{ 'orders.prod.confirmation' | translate }}</mat-label>
                <elder-select
                  appOrderConfirmationStateSelect
                  [allowNull]="true"
                  name="confirmation-state"
                  ngModel
                  elderSearchInput="state.value"
                  elderSearchInputKey="orderConfirmationState"
                >
                </elder-select>
              </mat-form-field>

              <mat-form-field>
                <mat-label>{{ 'context.production' | translate }}</mat-label>
                <elder-select
                  appOrderCompletionStateSelect
                  [allowNull]="true"
                  name="completionState-state"
                  ngModel
                  elderSearchInput="state.value"
                  elderSearchInputKey="completionStates"
                >
                </elder-select>
              </mat-form-field>
            </div>

            <div class="layout-row place-start-center gap-sm">
              <mat-form-field>
                <input
                  matInput
                  name="projectId"
                  ngModel
                  placeholder="{{ 'orders.projectNumber' | translate }}"
                  elderSearchInput
                />
              </mat-form-field>

              <mat-form-field>
                <mat-label>{{ 'context.labels' | translate }}</mat-label>
                <elder-multi-select-chips
                  [data]="labels$ | async"
                  valueAsId
                  ngModel
                  name="labels"
                  elderSearchInput
                  elderSearchInputKey="labelsAll"
                ></elder-multi-select-chips>
              </mat-form-field>
            </div>
            <div>
              <mat-checkbox
                matInput
                name="missingProductionRoutes"
                ngModel
                elderTripleStateCheckbox
                elderSearchInput
              >
                {{ 'orders.work.missingProductionRoutes' | translate }}
              </mat-checkbox>
            </div>
          </elder-search-panel>
        </elder-search-box>
      </ng-template>
    </elder-data-toolbar>

    <!-- editEnabled Column -->
    <ng-container matColumnDef="clearance">
      <th mat-header-cell *matHeaderCellDef style="width: 5px"></th>
      <td mat-cell *matCellDef="let order">
        <mat-icon>
          {{ isProcessable(order) ? 'lock_open' : 'lock' }}
        </mat-icon>
      </td>
    </ng-container>

    <!-- id Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.id' | translate }}
      </th>
      <td mat-cell *matCellDef="let order">{{ order.id }}</td>
    </ng-container>

    <!-- description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
        {{ 'context.description' | translate }}
      </th>
      <td mat-cell *matCellDef="let order">
        <div class="layout-col place-center-start">
          <span class="text-body-medium">{{ order.description }}</span>
          <span class="text-body-small">{{ order.projectDescription }}</span>
        </div>
      </td>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="Status">
      <th mat-header-cell *matHeaderCellDef style="width: 10%">
        {{ 'context.state' | translate }}
      </th>
      <td mat-cell *matCellDef="let order">
        {{ 'work_order_completion_state.' + order.completionState | translate }}
      </td>
    </ng-container>

    <!-- facility Column -->
    <!--    <ng-container matColumnDef="facility">-->
    <!--      <th mat-header-cell *matHeaderCellDef class="cell-small" mat-sort-header>{{'context.facility' | translate}}</th>-->
    <!--      <td mat-cell *matCellDef="let order"> {{order.company}} / {{order.manufactureFacility}} </td>-->
    <!--    </ng-container>-->

    <!-- groupId Column -->
    <ng-container matColumnDef="groupId">
      <th mat-header-cell *matHeaderCellDef class="cell-small" mat-sort-header>
        {{ 'orders.group' | translate }}
      </th>
      <td mat-cell *matCellDef="let order">{{ order.groupId }}</td>
    </ng-container>

    <!-- numOfPos Column -->
    <ng-container matColumnDef="numOfPos">
      <th mat-header-cell *matHeaderCellDef class="cell-small">
        {{ 'context.items' | translate }}
      </th>
      <td mat-cell *matCellDef="let order">{{ order.numOfPos }}</td>
    </ng-container>

    <!-- deliveryInterval Column -->
    <ng-container matColumnDef="deliveryInterval">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="cell-small"
        mat-sort-header="deliveryInterval.start"
      >
        {{ 'orders.deliveryDate' | translate }}
      </th>
      <td mat-cell *matCellDef="let order">
        {{ (order?.deliveryInterval | isoIntervalParse)?.start?.toString() | date: 'dd.MM.yyyy' }}
      </td>
    </ng-container>

    <!-- scheduleInterval Column -->
    <ng-container matColumnDef="scheduleInterval">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="cell-small"
        mat-sort-header="scheduleInterval.start"
      >
        {{ 'processing.planned' | translate }}
      </th>
      <td mat-cell *matCellDef="let order">
        {{ (order?.scheduleInterval | isoIntervalParse)?.start?.toString() | date: 'dd.MM.yyyy' }}
      </td>
    </ng-container>

    <!-- createdAt -->
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.createdAt' | translate }}
      </th>
      <td mat-cell *matCellDef="let order">
        {{ order.createdAt | date: 'short' }}
      </td>
    </ng-container>

    <!-- hints -->
    <ng-container matColumnDef="warn">
      <th mat-header-cell *matHeaderCellDef style="width: 5%"></th>
      <td mat-cell *matCellDef="let order">
        <app-work-order-hints [workOrder]="order"> </app-work-order-hints>
      </td>
    </ng-container>
  </elder-table>
</div>
